import React, { useState } from "react";
import HeaderTitle from "../../../components/HeaderTitle";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
} from "@syncfusion/ej2-react-grids";
import {
  HtmlEditor,
  Image,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import CustomTextArea from "../../../components/CustomTextArea";

//RichText
const toolbarSettings = {
  items: [
    "Bold",
    "Italic",
    "Underline",
    "StrikeThrough",
    "FontName",
    "FontSize",
    "FontColor",
    "BackgroundColor",
    "LowerCase",
    "UpperCase",
    "|",
    "Formats",
    "Alignments",
    "OrderedList",
    "UnorderedList",
    "Outdent",
    "Indent",
    "|",
    "CreateLink",
    "Image",
    "|",
    "|",
    "Undo",
    "Redo",
  ],
};

const quickToolbarSettings = {
  image: [
    "Replace",
    "Align",
    "Caption",
    "Remove",
    "InsertLink",
    "OpenImageLink",
    "-",
    "EditImageLink",
    "RemoveImageLink",
    "Display",
    "AltText",
    "Dimension",
  ],
};

//dummy insturance data
const insuranceData = [
  {
    insuranceType: "Homeowners - Structure",
    haveInsurance: "Yes",
    filedClaim: "No",
    amountReceived: 100,
    deductible: 10,
  },
  {
    insuranceType: "Homeowners - Contents",
    haveInsurance: "Yes",
    filedClaim: "No",
    amountReceived: 100,
    deductible: 10,
  },
  {
    insuranceType: "Flood - Structure",
    haveInsurance: "Yes",
    filedClaim: "No",
    amountReceived: 100,
    deductible: 10,
  },
  {
    insuranceType: "Flood - Contents",
    haveInsurance: "Yes",
    filedClaim: "No",
    amountReceived: 100,
    deductible: 10,
  },
  {
    insuranceType: "Wind - Structure",
    haveInsurance: "Yes",
    filedClaim: "No",
    amountReceived: 100,
    deductible: 10,
  },
];

const ScreeningAccounting = ({ className = "" }) => {
  const errors = {};
  const dummyRegister = {
    name: "dummy",
    onChange: () => {},
    onBlur: () => {},
    ref: () => {},
  };

  const femaOptions = [
    { label: "Application Submitted", value: "Application Submitted" },
    {
      label: "Application Approved - Accepted",
      value: "Application Approved - Accepted",
    },
    {
      label: "Application Approved - Declined",
      value: "Application Approved - Declined",
    },
    { label: "Application Denied", value: "Application Denied" },
    { label: "Undetermined", value: "Undetermined" },
  ];

  const sbaStatusOptions = [
    {
      label: "Application Submitted - Pending",
      value: "Application Submitted - Pending",
    },
    { label: "Application Withdrawn", value: "Application Withdrawn" },
    {
      label: "Loan Approved - Client Accepted",
      value: "Loan Approved - Client Accepted",
    },
    {
      label: "Loan Approved - Client Declined",
      value: "Loan Approved - Client Declined",
    },
    { label: "Loan Funds Received", value: "Loan Funds Received" },
    { label: "Loan Denied", value: "Loan Denied" },
    { label: "Intends to Apply", value: "Intends to Apply" },
    {
      label: "Not Applying / Did Not Apply",
      value: "Not Applying / Did Not Apply",
    },
    {
      label: "Not Eligible (Failed Income Test)",
      value: "Not Eligible (Failed Income Test)",
    },
  ];

  return (
    <div
      className={`box-border flex w-full max-w-[1640px] flex-col items-start justify-start ${className}`}
    >
      <HeaderTitle title="Home Insurance" />
      <div className="my-1 mb-2 flex w-full">
        <GridComponent
          dataSource={insuranceData}
          allowPaging={true}
          allowSorting={true}
          // filterSettings={{ type: "CheckBox" }}
          // allowFiltering={true}
          sortSettings={{ allowSorting: true }}
          pageSettings={{ pageSize: 5 }}
          cssClass="new-grid-color"
        >
          <ColumnsDirective>
            <ColumnDirective
              field="insuranceType"
              headerText="Insurance Type"
              width="200"
            />
            <ColumnDirective
              field="haveInsurance"
              headerText="Have Insurance?"
              width="150"
              template={(props) => (
                <span className="font-medium text-green-600">
                  {props.haveInsurance}
                </span>
              )}
            />
            <ColumnDirective
              field="filedClaim"
              headerText="Filed a Claim?"
              width="150"
              template={(props) => (
                <span className="font-medium text-red-500">
                  {props.filedClaim}
                </span>
              )}
            />
            <ColumnDirective
              field="amountReceived"
              headerText="Amount Received"
              width="150"
              template={(props) => (
                <span className="font-medium text-green-600">
                  + ${props.amountReceived.toFixed(2)}
                </span>
              )}
            />
            <ColumnDirective
              field="deductible"
              headerText="Deductible"
              width="120"
              template={(props) => (
                <span className="font-medium text-red-500">
                  - ${props.deductible.toFixed(2)}
                </span>
              )}
            />
          </ColumnsDirective>
          <Inject services={[Page]} />
        </GridComponent>
      </div>
      <HeaderTitle title="Litigation" />
      <div className="my-1 mb-2 flex  w-full gap-2 text-sm">
        <div className="flex w-fit flex-col whitespace-nowrap">
          <label className="mb-1 block font-normal text-[#242424]">
            Are you in litigation with any insurance company or contractor?
          </label>
          <div className="mt-4 flex items-center gap-4">
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="litigation" defaultChecked />
              Yes
            </label>
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="litigation" />
              No
            </label>
          </div>
        </div>
        <div className="flex w-full flex-col">
          <label className="mb-1 block font-normal text-[#242424]">
            Litigation Notes
          </label>
          <div className="w-full">
            {/* <RichTextEditorComponent
            height={350}
            toolbarSettings={toolbarSettings}
            quickToolbarSettings={quickToolbarSettings}
          >
            <Inject
              services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]}
            />
          </RichTextEditorComponent> */}
            <CustomTextArea name="litigationnotes" rows={1} errors={errors} />
          </div>
        </div>
      </div>

      <HeaderTitle title="FEMA" />

      <div className="my-1 mb-2 grid w-full grid-cols-4 gap-4 text-sm">
        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Have you applied for FEMA assistance, if available?
          </label>
          <div className="mt-4 flex gap-6">
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="femaApplied" defaultChecked />
              Yes
            </label>
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="femaApplied" />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            FEMA No.
          </label>
          <CustomInput
            name="femaNumber"
            placeholder="Enter FEMA No."
            errors={errors}
            register={dummyRegister}
          />
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            FEMA Application Results
          </label>
          <CustomSelect
            name="femaResult"
            placeholder="Select Results"
            options={femaOptions}
            errors={errors}
            register={dummyRegister}
          />

          <div className="mt-4">
            <label className="mb-1 block font-normal text-[#242424]">
              Have you submitted a FEMA appeal?
            </label>
            <div className="mt-4 flex gap-6">
              <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
                <input type="radio" name="femaAppealSubmitted" defaultChecked />
                Yes
              </label>
              <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
                <input type="radio" name="femaAppealSubmitted" />
                No
              </label>
            </div>
          </div>
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Amount of FEMA Assistance Received
          </label>
          <CustomInput
            name="femaAmount"
            placeholder="Enter Amount"
            errors={errors}
            register={dummyRegister}
          />

          <div className="mt-4">
            <label className="mb-1 block font-normal text-[#242424]">
              Has the FEMA appeal been resolved?
            </label>
            <div className="mt-4 flex gap-6">
              <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
                <input type="radio" name="femaAppealResolved" defaultChecked />
                Yes
              </label>
              <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
                <input type="radio" name="femaAppealResolved" />
                No
              </label>
            </div>
          </div>
        </div>
      </div>
      <HeaderTitle title="SBA" />

      <div className="my-1 grid w-full grid-cols-3 gap-4 text-sm">
        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Have you applied for an SBA Loan?
          </label>
          <div className="mt-4 flex gap-6">
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaApplied" defaultChecked />
              Yes
            </label>
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaApplied" />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            SBA Loan Status
          </label>
          <CustomSelect
            name="sbaStatus"
            placeholder="Select a status"
            options={sbaStatusOptions}
            errors={errors}
            register={dummyRegister}
          />
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Amount of SBA Loan Received
          </label>
          <CustomInput
            name="sbaAmount"
            placeholder="Enter amount"
            errors={errors}
            register={dummyRegister}
          />
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Have you submitted an SBA appeal?
          </label>
          <div className="mt-4 flex gap-6">
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaAppealSubmitted" defaultChecked />
              Yes
            </label>
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaAppealSubmitted" />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            Has the SBA appeal been resolved?
          </label>
          <div className="mt-4 flex gap-6">
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaAppealResolved" defaultChecked />
              Yes
            </label>
            <label className="mb-1 flex items-center gap-2 font-normal text-[#242424]">
              <input type="radio" name="sbaAppealResolved" />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="mb-1 block font-normal text-[#242424]">
            How did you spend monies?
          </label>
          <CustomInput
            name="sbaSpending"
            placeholder="Enter amount"
            errors={errors}
            register={dummyRegister}
          />
        </div>
      </div>
    </div>
  );
};
export default ScreeningAccounting;
